import React from "react";

export default () => (
  <svg
    width="148"
    height="158"
    viewBox="0 0 148 158"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <path
        d="M79.1559 137.344C117.142 137.344 147.936 106.598 147.936 68.6718C147.936 30.7454 117.142 0 79.1559 0C41.1696 0 10.3757 30.7454 10.3757 68.6718C10.3757 106.598 41.1696 137.344 79.1559 137.344Z"
        fill="#F2F2F2"
      />
      <path
        d="M147.939 129.995C147.939 131.405 115.886 139.046 76.3479 139.046C36.8094 139.046 4.75708 131.405 4.75708 129.995C4.75708 128.585 36.8094 130.923 76.3479 130.923C115.886 130.923 147.939 128.585 147.939 129.995Z"
        fill="#3F3D56"
      />
      <path
        opacity="0.1"
        d="M147.939 129.995C147.939 131.405 115.886 139.046 76.3479 139.046C36.8094 139.046 4.75708 131.405 4.75708 129.995C4.75708 128.585 36.8094 130.923 76.3479 130.923C115.886 130.923 147.939 128.585 147.939 129.995Z"
        fill="black"
      />
      <path
        d="M76.3479 132.548C115.886 132.548 147.939 131.405 147.939 129.995C147.939 128.585 115.886 127.442 76.3479 127.442C36.8094 127.442 4.75708 128.585 4.75708 129.995C4.75708 131.405 36.8094 132.548 76.3479 132.548Z"
        fill="#3F3D56"
      />
      <path d="M144.746 129.299V106.324" stroke="#3F3D56" stroke-width="2" stroke-miterlimit="10" />
      <path
        d="M144.746 109.573C146.543 109.573 148 108.118 148 106.324C148 104.529 146.543 103.075 144.746 103.075C142.949 103.075 141.492 104.529 141.492 106.324C141.492 108.118 142.949 109.573 144.746 109.573Z"
        fill="#3F3D56"
      />
      <path
        d="M144.746 120.484C144.746 120.484 144.281 110.501 134.751 111.661L144.746 120.484Z"
        fill="#3F3D56"
      />
      <path d="M13.2488 131.011V55.4124" stroke="#3F3D56" stroke-width="2" stroke-miterlimit="10" />
      <path
        d="M13.2488 58.625C15.046 58.625 16.5029 57.1703 16.5029 55.376C16.5029 53.5816 15.046 52.127 13.2488 52.127C11.4515 52.127 9.99463 53.5816 9.99463 55.376C9.99463 57.1703 11.4515 58.625 13.2488 58.625Z"
        fill="#3F3D56"
      />
      <path
        d="M3.25413 114.07C5.05133 114.07 6.50825 112.616 6.50825 110.821C6.50825 109.027 5.05133 107.572 3.25413 107.572C1.45692 107.572 0 109.027 0 110.821C0 112.616 1.45692 114.07 3.25413 114.07Z"
        fill="#3F3D56"
      />
      <path
        d="M13.249 71.9721C13.249 71.9721 12.7841 61.9894 3.25415 63.1498L13.249 71.9721Z"
        fill="#3F3D56"
      />
      <path
        d="M13.249 100.272C13.249 100.272 12.7841 90.2892 3.25415 91.4496L13.249 100.272Z"
        fill="#3F3D56"
      />
      <path
        d="M13.249 130.118C13.249 130.118 15.3409 111.75 3.25415 110.821"
        stroke="#3F3D56"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M23.2451 114.07C25.0423 114.07 26.4992 112.616 26.4992 110.821C26.4992 109.027 25.0423 107.572 23.2451 107.572C21.4479 107.572 19.991 109.027 19.991 110.821C19.991 112.616 21.4479 114.07 23.2451 114.07Z"
        fill="#3F3D56"
      />
      <path
        d="M13.2504 130.118C13.2504 130.118 11.1584 111.75 23.2452 110.821"
        stroke="#3F3D56"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M23.4433 83.5935C25.2405 83.5935 26.6975 82.1388 26.6975 80.3445C26.6975 78.5501 25.2405 77.0955 23.4433 77.0955C21.6461 77.0955 20.1892 78.5501 20.1892 80.3445C20.1892 82.1388 21.6461 83.5935 23.4433 83.5935Z"
        fill="#3F3D56"
      />
      <path
        d="M13.4486 99.6416C13.4486 99.6416 11.3567 81.2728 23.4434 80.3445"
        stroke="#3F3D56"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path d="M119.717 128.834V82.8843" stroke="#3F3D56" stroke-width="2" stroke-miterlimit="10" />
      <path
        d="M119.717 86.1333C121.514 86.1333 122.971 84.6786 122.971 82.8843C122.971 81.0899 121.514 79.6353 119.717 79.6353C117.92 79.6353 116.463 81.0899 116.463 82.8843C116.463 84.6786 117.92 86.1333 119.717 86.1333Z"
        fill="#3F3D56"
      />
      <path
        d="M119.717 96.1162C119.717 96.1162 120.181 86.1334 129.711 87.2938L119.717 96.1162Z"
        fill="#3F3D56"
      />
      <path
        d="M119.717 127.941C119.717 127.941 117.625 109.573 129.711 108.644"
        stroke="#3F3D56"
        stroke-width="2"
        stroke-miterlimit="10"
      />
      <path
        d="M129.712 111.894C131.509 111.894 132.966 110.439 132.966 108.645C132.966 106.85 131.509 105.396 129.712 105.396C127.914 105.396 126.458 106.85 126.458 108.645C126.458 110.439 127.914 111.894 129.712 111.894Z"
        fill="#3F3D56"
      />
      <path
        d="M115.825 47.8922C122.831 47.8922 128.511 42.2216 128.511 35.2265C128.511 28.2314 122.831 22.5608 115.825 22.5608C108.819 22.5608 103.14 28.2314 103.14 35.2265C103.14 42.2216 108.819 47.8922 115.825 47.8922Z"
        fill="#FF6584"
      />
      <path
        d="M94.8932 123.28C103.541 123.28 110.552 116.28 110.552 107.646C110.552 99.0114 103.541 92.0117 94.8932 92.0117C86.2451 92.0117 79.2344 99.0114 79.2344 107.646C79.2344 116.28 86.2451 123.28 94.8932 123.28Z"
        fill="#2F2E41"
      />
      <path d="M97.2716 128.426H102.029V119.916H97.2716V128.426Z" fill="#2F2E41" />
      <path d="M87.7575 128.426H92.5146V119.916H87.7575V128.426Z" fill="#2F2E41" />
      <path
        d="M89.8883 130.601C91.7844 129.508 92.9887 128.047 92.5782 127.337C92.1676 126.627 90.2978 126.938 88.4017 128.03C86.5056 129.123 85.3013 130.585 85.7118 131.295C86.1223 132.005 87.9922 131.694 89.8883 130.601Z"
        fill="#2F2E41"
      />
      <path
        d="M99.2044 130.601C101.101 129.508 102.305 128.047 101.894 127.337C101.484 126.627 99.6139 126.938 97.7178 128.03C95.8218 129.123 94.6175 130.585 95.028 131.295C95.4385 132.005 97.3084 131.694 99.2044 130.601Z"
        fill="#2F2E41"
      />
      <path
        d="M94.4968 109.031C97.4525 109.031 99.8485 106.639 99.8485 103.688C99.8485 100.737 97.4525 98.3445 94.4968 98.3445C91.5411 98.3445 89.145 100.737 89.145 103.688C89.145 106.639 91.5411 109.031 94.4968 109.031Z"
        fill="white"
      />
      <path
        d="M92.674 103.193C93.6593 103.193 94.458 102.396 94.458 101.412C94.458 100.428 93.6593 99.6309 92.674 99.6309C91.6888 99.6309 90.8901 100.428 90.8901 101.412C90.8901 102.396 91.6888 103.193 92.674 103.193Z"
        fill="#3F3D56"
      />
      <path
        d="M110.083 93.1065C111.347 87.453 107.306 81.7403 101.055 80.3469C94.8054 78.9535 88.7137 82.407 87.4493 88.0606C86.1849 93.7142 90.3271 95.7993 96.5772 97.1927C102.827 98.5861 108.819 98.7601 110.083 93.1065Z"
        fill="#3739B5"
      />
      <path
        d="M88.3717 105.347C88.9058 104.101 86.1162 101.714 82.1409 100.015C78.1657 98.3166 74.5101 97.9496 73.9759 99.1956C73.4418 100.442 76.2314 102.829 80.2067 104.528C84.1819 106.226 87.8375 106.593 88.3717 105.347Z"
        fill="#2F2E41"
      />
      <path
        d="M117.707 115.836C118.241 114.59 115.452 112.203 111.476 110.504C107.501 108.805 103.846 108.438 103.311 109.684C102.777 110.93 105.567 113.318 109.542 115.016C113.517 116.715 117.173 117.082 117.707 115.836Z"
        fill="#2F2E41"
      />
      <path
        d="M98.0258 114.473C98.0258 115.418 97.6499 116.324 96.9808 116.992C96.3117 117.66 95.4042 118.036 94.458 118.036C93.5117 118.036 92.6042 117.66 91.9351 116.992C91.266 116.324 90.8901 115.418 90.8901 114.473C90.8901 112.506 92.4875 112.099 94.458 112.099C96.4284 112.099 98.0258 112.506 98.0258 114.473Z"
        fill="white"
      />
      <path d="M76.2295 102.978V80.0027" stroke="#3739B5" stroke-width="2" stroke-miterlimit="10" />
      <path
        d="M76.2295 83.2517C78.0267 83.2517 79.4836 81.797 79.4836 80.0027C79.4836 78.2083 78.0267 76.7537 76.2295 76.7537C74.4323 76.7537 72.9753 78.2083 72.9753 80.0027C72.9753 81.797 74.4323 83.2517 76.2295 83.2517Z"
        fill="#3739B5"
      />
      <path
        d="M76.2297 94.1628C76.2297 94.1628 75.7648 84.1801 66.2349 85.3404L76.2297 94.1628Z"
        fill="#3739B5"
      />
      <path
        d="M45.6352 87.2471L46.8966 90.2156H48.0137L46.428 82.6954C46.428 77.8684 44.0946 73.7898 39.26 73.7898H39.2599C37.6388 73.7898 36.0842 74.4328 34.9379 75.5772C33.7917 76.7217 33.1477 78.2739 33.1477 79.8924V87.2677C33.1477 87.6549 33.2241 88.0382 33.3724 88.3958C33.5208 88.7535 33.7383 89.0785 34.0125 89.3522C34.2866 89.6259 34.6121 89.8431 34.9703 89.9912C35.3285 90.1394 35.7125 90.2156 36.1002 90.2156H44.768L45.6352 87.2471Z"
        fill="#2F2E41"
      />
      <path
        d="M50.9102 117.1C50.9102 117.1 67.3619 115.121 69.344 118.684C71.3262 122.246 69.9387 125.214 67.3619 126.996C64.7851 128.777 50.5137 136.891 50.5137 136.891L49.3244 138.87L46.7477 138.474L44.1709 136.099L45.3602 133.922C45.3602 133.922 55.2709 127.985 55.4691 126.402C55.4691 126.402 46.3512 130.558 45.3602 129.766C44.3691 128.975 33.2691 125.214 35.0531 123.037C36.837 120.861 41.3959 117.694 41.3959 117.694L50.9102 117.1Z"
        fill="#2F2E41"
      />
      <path
        opacity="0.1"
        d="M50.9102 117.1C50.9102 117.1 67.3619 115.121 69.344 118.684C71.3262 122.246 69.9387 125.214 67.3619 126.996C64.7851 128.777 50.5137 136.891 50.5137 136.891L49.3244 138.87L46.7477 138.474L44.1709 136.099L45.3602 133.922C45.3602 133.922 55.2709 127.985 55.4691 126.402C55.4691 126.402 46.3512 130.558 45.3602 129.766C44.3691 128.975 33.2691 125.214 35.0531 123.037C36.837 120.861 41.3959 117.694 41.3959 117.694L50.9102 117.1Z"
        fill="black"
      />
      <path
        d="M48.7298 137.089C48.7298 137.089 51.703 136.495 51.1084 138.474C50.5137 140.453 50.1173 144.411 51.1084 145.4C52.0994 146.39 55.2709 150.744 52.0994 151.14C48.928 151.535 45.5584 147.577 45.5584 147.577C45.5584 147.577 43.378 141.244 41.7923 140.651C40.2066 140.057 38.6209 137.682 39.4138 137.089C40.2066 136.495 44.9638 132.735 45.3602 132.933C45.7566 133.13 45.5584 135.307 45.5584 135.307C45.5584 135.307 47.1441 137.88 48.7298 137.089Z"
        fill="#2F2E41"
      />
      <path
        d="M49.0274 94.8365L56.3613 99.9819C56.3613 99.9819 61.9112 94.2427 61.9112 90.8784C61.9112 87.5141 64.8844 81.1812 66.2719 83.754C67.6594 86.3267 64.6862 92.4616 64.6862 92.4616L59.1362 105.523C59.1362 105.523 55.9648 106.117 54.1809 104.732C52.397 103.346 47.4417 100.576 47.4417 100.576L49.0274 94.8365Z"
        fill="#FFB9B9"
      />
      <path
        d="M41.7924 86.2277C44.8576 86.2277 47.3424 83.7468 47.3424 80.6865C47.3424 77.6262 44.8576 75.1453 41.7924 75.1453C38.7272 75.1453 36.2424 77.6262 36.2424 80.6865C36.2424 83.7468 38.7272 86.2277 41.7924 86.2277Z"
        fill="#FFB9B9"
      />
      <path
        d="M44.6665 84.5455C44.6665 84.5455 42.6843 89.6909 43.4772 90.8784C44.27 92.0658 45.2611 92.0658 46.054 92.4616C46.4504 92.6595 50.6129 94.2427 50.6129 95.4301C50.5937 96.193 50.3897 96.94 50.0182 97.607L49.4236 100.971L44.4682 104.138L37.9272 103.346L32.9719 100.576C32.9719 100.576 32.179 93.2532 34.3594 92.0658C36.5397 90.8784 39.1165 88.1077 38.9183 87.1182C38.7201 86.1287 38.5218 83.7539 38.5218 83.7539L44.6665 84.5455Z"
        fill="#FFB9B9"
      />
      <path
        d="M52.9917 96.8154C52.9917 96.8154 50.0185 99.784 50.0185 100.18C50.0185 100.576 52.0006 102.357 50.6131 104.731C49.2256 107.106 49.2256 113.043 49.2256 113.043L44.4685 114.033L35.5489 113.241L34.1614 99.5861C34.1614 99.5861 37.7292 100.18 38.5221 100.773C39.3149 101.367 41.4953 99.9819 43.081 99.9819C44.6667 99.9819 49.2256 99.1903 49.2256 99.1903L48.8292 97.607L50.4149 94.8364L52.9917 96.8154Z"
        fill="#3739B5"
      />
      <path
        d="M41.7925 117.892C41.7925 117.892 61.812 108.986 63.3978 114.726C64.9835 120.465 65.1817 134.318 65.1817 134.318C65.1817 134.318 66.1727 143.817 67.362 144.807C68.5513 145.796 67.362 148.765 67.362 148.765L64.3888 149.754L61.6138 148.567L60.4246 145.4C60.4246 145.4 60.0281 138.276 58.4424 134.714C56.8567 131.151 56.8567 122.84 57.0549 122.444C57.0549 122.444 49.3246 131.943 41.7925 131.349C34.2603 130.756 33.1702 129.073 33.1702 129.073C33.1702 129.073 36.8371 117.892 41.7925 117.892Z"
        fill="#2F2E41"
      />
      <path
        d="M66.1728 145.796C66.1728 145.796 66.9657 143.025 68.7496 145.202C70.5335 147.379 78.6603 150.744 78.8585 151.139C79.0567 151.535 82.6246 153.712 78.4621 156.681C74.2996 159.649 68.7496 156.681 68.7496 156.681C68.7496 156.681 63.9925 155.097 62.8032 155.295C61.6139 155.493 59.2354 154.306 59.0372 153.316C58.8389 152.327 59.3072 143.628 60.3614 144.514C61.4157 145.4 62.605 147.775 62.605 147.775C62.605 147.775 66.5693 148.765 66.1728 145.796Z"
        fill="#2F2E41"
      />
      <path
        d="M48.5316 112.549C48.5316 112.549 49.6218 112.45 49.4236 115.023C49.4236 115.023 42.5852 117.101 41.3959 118.882C40.2066 120.663 35.0531 126.006 34.2602 129.766C34.2602 129.766 28.512 128.381 31.6834 118.486L35.4122 110.414C35.4122 110.414 37.6298 114.924 48.5316 112.549Z"
        fill="#2F2E41"
      />
      <path
        d="M43.8662 117.359L37.1344 114.429C37.1344 114.429 33.9629 107.898 33.9629 104.732C33.9245 102.91 33.7839 101.091 33.5417 99.285C33.3919 98.1489 33.5224 96.9935 33.922 95.9193C34.3216 94.8451 34.9781 93.8847 35.8343 93.1216C36.5343 92.5104 37.3202 92.0659 38.1254 92.0659C38.1254 92.0659 40.504 96.4198 40.1076 100.378C39.7111 104.336 40.7022 110.273 40.7022 110.273L49.6587 115.059"
        fill="#FFB9B9"
      />
      <path
        opacity="0.1"
        d="M43.8664 117.359L37.1346 114.429C37.1346 114.429 33.9631 107.898 33.9631 104.732C33.9631 103.082 40.9006 98.2009 40.5042 102.159C40.1078 106.117 40.7024 110.273 40.7024 110.273L49.6589 115.059"
        fill="black"
      />
      <path
        d="M40.7024 101.763L40.0704 104.435L36.5399 106.117H33.5667L32.1792 99.7839C32.1792 99.7839 34.629 99.2666 35.8817 99.9211C37.1345 100.576 40.0765 100.732 40.0765 100.732L40.7024 101.763Z"
        fill="#3739B5"
      />
      <path
        d="M43.9907 74.0545C42.9153 73.7823 40.3655 73.7898 39.9924 73.7898C39.0936 73.7898 38.2035 73.9666 37.3731 74.31C36.5427 74.6534 35.7881 75.1568 35.1526 75.7914C34.517 76.426 34.0128 77.1793 33.6688 78.0085C33.3249 78.8376 33.1478 79.7262 33.1478 80.6236L30.571 90.2157H35.5867L36.5175 86.6534L37.8389 90.2157H40.3638L40.5808 88.075L41.4354 90.2157H44.2478C42.1415 85.4573 41.021 81.12 43.7883 78.4429C45.657 78.697 47.233 78.1973 47.4898 77.1858C47.7857 76.0204 46.2191 74.6184 43.9907 74.0545Z"
        fill="#2F2E41"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="148" height="158" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
